import { ReportProperties } from './report-properties';
import { Observable, Subject, Subscription } from 'rxjs';
import { UpdateMetadata, PropertyPreviewMetadata, FieldType } from '../_services/report-template-design.service';
import { TemplateDefinition } from './report-template';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from '../_services/lang-update.service';

export class ReportPageMargin extends ReportProperties {

  public onUpdateTop: Observable<UpdateMetadata>;
  private onUpdateTop$: Subject<UpdateMetadata>;
  public onUpdateBottom: Observable<UpdateMetadata>;
  private onUpdateBottom$: Subject<UpdateMetadata>;
  public onUpdateLeft: Observable<UpdateMetadata>;
  private onUpdateLeft$: Subject<UpdateMetadata>;
  public onUpdateRight: Observable<UpdateMetadata>;
  private onUpdateRight$: Subject<UpdateMetadata>;

  private baseDef: TemplateDefinition;
  private readonly metaTop = 'pageMarginTop';
  private readonly metaBottom = 'pageMarginBottom';
  private readonly metaLeft = 'pageMarginLeft';
  private readonly metaRight = 'pageMarginRight';

  constructor(templateDef: TemplateDefinition,
    protected translate: TranslateService,
    protected langService: LangUpdateService
) {

    super('Page Margin', translate, langService);

    this.onUpdateTop$ = new Subject();
    this.onUpdateTop = this.onUpdateTop$.asObservable();
    this.onUpdateBottom$ = new Subject();
    this.onUpdateBottom = this.onUpdateBottom$.asObservable();
    this.onUpdateLeft$ = new Subject();
    this.onUpdateLeft = this.onUpdateLeft$.asObservable();
    this.onUpdateRight$ = new Subject();
    this.onUpdateRight = this.onUpdateRight$.asObservable();

    this.baseDef = templateDef;

    this.setChainUpdate();
    this.setPreviewMetadata();
  }

  public getTop(): string {
    return [this.baseDef.pageMarginTop.toString(), 'mm'].join('');
  }
  public getBottom(): string {
    return [this.baseDef.pageMarginBottom.toString(), 'mm'].join('');
  }
  public getLeft(): string {
    return [this.baseDef.pageMarginLeft.toString(), 'mm'].join('');
  }
  public getRight(): string {
    return [this.baseDef.pageMarginRight.toString(), 'mm'].join('');
  }

  public getTopNum(): number {
    return this.baseDef.pageMarginTop;
  }
  public getBottomNum(): number {
    return this.baseDef.pageMarginBottom;
  }
  public getLeftNum(): number {
    return this.baseDef.pageMarginLeft;
  }
  public getRightNum(): number {
    return this.baseDef.pageMarginRight;
  }

  public getPaddedWidthNum(value: number): number {
    const left = this.baseDef.pageMarginLeft;
    const right = this.baseDef.pageMarginRight;
    return value - (left + right);
  }

  public getPaddedWidth(value: number): string {
    const paddedWidth = [this.getPaddedWidthNum(value), 'mm'];
    return paddedWidth.join('');
  }

  public getPaddedHeightNum(value: number): number {
    const top = this.baseDef.pageMarginTop;
    const bottom = this.baseDef.pageMarginBottom;
    return value - (top + bottom);
  }

  public getPaddedHeight(value: number): string {
    const paddedHeight = [this.getPaddedHeightNum(value), 'mm'];
    return paddedHeight.join('');
  }

  public getTemplateJSON(): TemplateDefinition {
    return this.baseDef;
  }

  protected getPreviewMetadata(): PropertyPreviewMetadata[] {
    return [
      {
        name: this.metaTop, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
      },
      {
        name: this.metaBottom, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
      },
      {
        name: this.metaLeft, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
      },
      {
        name: this.metaRight, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
      }
    ];
  }

  protected setUpdateMetadata(metadata: UpdateMetadata) {
    switch (metadata.name) {
      case this.metaTop:
        this.baseDef[metadata.name] = metadata.value as number;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateTop$.next(metadata);
        break;
      case this.metaBottom:
        this.baseDef[metadata.name] = metadata.value as number;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateBottom$.next(metadata);
        break;
      case this.metaLeft:
        this.baseDef[metadata.name] = metadata.value as number;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateLeft$.next(metadata);
        break;
      case this.metaRight:
        this.baseDef[metadata.name] = metadata.value as number;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdateRight$.next(metadata);
        break;
    }
  }

  protected setChainUpdateFunction(subscribers: Array<Subscription>) {  }
}
